import { useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({ type: 'create-configuration' })
  }
}

export function notEmpty(value1, value2) {
  return !!(value1 && value2)
}
